import { Card } from "@/src/components/cards";
import { closeDrawer, openDrawer } from "@/src/components/dialogs";
import { InfiniteFetchableList } from "@/src/components/fetchableLists";
import { ServiceType, Service } from "@/src/data/allTypes";
import { USER } from "@/src/data/globalVariables";
import apiFetch from "@/src/utils/apiFetch";
import { getHospitalId, uid } from "@/src/utils/utils";
import { useState } from "react";

export function ServicesChoice({
  types,
  hospitalId,
  current,
  onChange,
}: {
  types?: ServiceType[];
  hospitalId: string | null | undefined;
  current: Service | null | undefined;
  onChange: (newService: Service) => void;
}) {
  const [searchKey, setSearchKey] = useState<string | null>("");

  return (
    <div className="c1 gap10">
      <InfiniteFetchableList
        queryKey={["ServicesChoice", hospitalId, uid(), JSON.stringify(types)]}
        getFunction={(limit, offset, searchKey) => {
          return apiFetch("services", "loadMany", {
            hospitalId,
            limit,
            offset,
            searchKey,
            types,
          });
        }}
        searchKey={searchKey}
        onSearch={(newValue) => {
          setSearchKey(newValue);
        }}
      >
        {(data) => (
          <div className="grid c1 gap15">
            {data?.map((service) => {
              if (!service.name) return null;
              return (
                <Card
                  key={uid()}
                  color={current ? "simple" : "simple"}
                  title={service.name}
                  subTitle={
                    USER.get()?.service?.hospital?.name ==
                    service.hospital?.name
                      ? ""
                      : service.hospital?.name
                  }
                  onClick={() => {
                    onChange(service);
                  }}
                />
              );
            })}
          </div>
        )}
      </InfiniteFetchableList>
    </div>
  );
}

export async function openServiceChoiceDrawer({
  types,
  hospitalId,
  current,
  onSelect,
}: {
  types?: ServiceType[];
  hospitalId: string | null | undefined;
  current: Service | null | undefined;
  onSelect: (newService: Service | null | undefined) => void;
}) {
  await openDrawer({
    id: "serviceChoiceDrawer",
    title: "Choisir un service",
    additionalClasses: ["small"],
    content: (
      <ServicesChoice
        types={types}
        hospitalId={hospitalId}
        current={current}
        onChange={async (service) => {
          await onSelect(service);
        }}
      ></ServicesChoice>
    ),
  });
}
